import { FC, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'hooks/store'
import { InfoField } from 'types/infoField'
import {
  CourseOrderItem,
  CourseStatus,
  CourseTabTitle,
  getCourseStatusName
} from 'share/domain/course'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import { CoursesContainer } from 'components/atoms/Layout'
import InfoFields from 'components/atoms/InfoFields'

const attorneyContent = (
  <>
    Your course has been canceled. Please{' '}
    <Link to='/dashboard/lawfirminformation'>contact your attorney</Link> for
    more information.
  </>
)

interface CourseTabCanceledProps {
  course: CourseOrderItem
}

const CourseTabCanceled: FC<CourseTabCanceledProps> = ({ course }) => {
  const dispatch = useAppDispatch()
  const activeCourse = useAppSelector((state) => state.activeCourse)

  useEffect(() => {
    let title = ''
    if (activeCourse?.activeTab) {
      title =
        activeCourse.activeTab === 'first'
          ? CourseTabTitle.CANCELED_FIRST_COURSE
          : CourseTabTitle.CANCELED_SECOND_COURSE
    }

    dispatch(setTitle(title))
  }, [activeCourse])

  const fields = useMemo<InfoField[]>(() => {
    const status = getCourseStatusName(
      !course.providerName ? CourseStatus.Canceled : course.courseStatus
    )

    const result: InfoField[] = [
      {
        content: status,
        key: 'courseStart',
        title: 'Course Status'
      },
      {
        content: course.providerName,
        key: 'courseProvider',
        title: 'Course Provider'
      },
      {
        content: attorneyContent,
        key: 'whatYouNeedToKnow',
        title: 'What you need to know:'
      }
    ]

    if (!course.providerName) result.splice(1, 1)

    return result
  }, [course.courseStatus, course.providerName])

  return (
    <CoursesContainer data-testid='course-tab-cancel-content'>
      <InfoFields fields={fields} />
    </CoursesContainer>
  )
}

export default CourseTabCanceled
